import { any } from 'apprise-core/action';
import { manageTenant, Tenant } from 'apprise-core/tenant';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';



export const useTenantOracle = () => {

    const logged = useOracle()

    const idOf = (tenant: string | Tenant | undefined) => typeof tenant === 'string' ? tenant : tenant?.id

    const can = {

        manageAll: () => logged.can(manageTenant)

        ,
        
        manage: (tenant?: string | Tenant) => logged.hasNoTenant() || logged.managedTenants().includes(idOf(tenant) ?? any)

    }

    const self = {


        canAdd: () => logged.hasNoTenant() && can.manageAll()

        ,

        canEdit: can.manage

        ,

        canRemove: (tenant?: Tenant | undefined) => {

            
            if (!tenant)
                return can.manageAll()


            const state = tenant.lifecycle.state === 'inactive' 

            return state && can.manage(tenant)
        
        }

    }

    return self
}


